import { render, staticRenderFns } from "./ProductQuestionEdit.vue?vue&type=template&id=3a002c22&"
import script from "./ProductQuestionEdit.vue?vue&type=script&lang=js&"
export * from "./ProductQuestionEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductQuestionEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports